import { render, staticRenderFns } from "./Register-3.vue?vue&type=template&id=14077277&scoped=true&"
import script from "./Register-3.vue?vue&type=script&lang=js&"
export * from "./Register-3.vue?vue&type=script&lang=js&"
import style0 from "./Register-3.vue?vue&type=style&index=0&id=14077277&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14077277",
  null
  
)

export default component.exports